import { render, staticRenderFns } from "./ui-loader.vue?vue&type=template&id=359c5c3e&"
import script from "./ui-loader.vue?vue&type=script&lang=js&"
export * from "./ui-loader.vue?vue&type=script&lang=js&"
import style0 from "./ui-loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359c5c3e')) {
      api.createRecord('359c5c3e', component.options)
    } else {
      api.reload('359c5c3e', component.options)
    }
    module.hot.accept("./ui-loader.vue?vue&type=template&id=359c5c3e&", function () {
      api.rerender('359c5c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-loader/ui-loader.vue"
export default component.exports